module.exports = __webpack_public_path__ + "5dd499d625a2415aef316563427b867a.svg";